import {
  InputButton,
  NumberInput,
  type NumberInputProps,
} from '@homestake/shared/ui';
import { observer } from '@legendapp/state/react';
import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { autoBetState$ } from '../../../state';

export type AutoBetNumberOfBetsInputProps = NumberInputProps;

export const AutoBetNumberOfBetsInput = observer(
  (props: AutoBetNumberOfBetsInputProps) => {
    const { t } = useTranslation();
    const handleInfiniteToggle = () => {
      autoBetState$.hasInfiniteBets.set((prev) => !prev);
      if (!autoBetState$.hasInfiniteBets.peek()) {
        // Set a default value when toggling off infinite
        autoBetState$.numberOfBets.set(10);
      }
    };

    return (
      <NumberInput
        allowDecimal={false}
        allowNegative={false}
        clampBehavior="strict"
        data-test-id="number-of-bets-input"
        disabled={autoBetState$.isAutoBetting.get()}
        flex={1}
        label={t('autobet.autoBetNumberOfBetsInput.label')}
        labelProps={{
          'data-test-id': 'number-of-bets-input-label',
        }}
        max={1000}
        min={1}
        onChange={(value) => {
          if (!autoBetState$.hasInfiniteBets.get()) {
            autoBetState$.numberOfBets.set(Number(value) || 1);
          }
        }}
        placeholder={autoBetState$.hasInfiniteBets.get() ? '∞' : '10'}
        readOnly={autoBetState$.hasInfiniteBets.get()}
        rightSection={
          <Group gap={4}>
            <InputButton
              data-test-id="infinite-bets-button"
              isActive={autoBetState$.hasInfiniteBets.get()}
              onClick={handleInfiniteToggle}
            >
              ∞
            </InputButton>
          </Group>
        }
        rightSectionWidth="auto"
        value={
          autoBetState$.hasInfiniteBets.get()
            ? ''
            : autoBetState$.numberOfBets.get()
        }
        {...props}
      />
    );
  }
);
